/**
 * We want to know where to launch the CSB instance for this application, either US or EU
 * and to do that, we check the browser's timezone, and determine if it's
 * closer to US or Europe.
 *
 * Note: We use `FR` here as a proxy for Europe.
 */
export const bestCountryToLaunchCSB = (): "US" | "FR" => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const parts = timezone.split("/");

    const region = parts[0];

    if (["Europe", "Africa", "Indian", "Arctic"].includes(region)) {
      return "FR";
    }
  } catch {
    // Not a worry, just use default.
  }

  // Regions that will return US:
  // America, Antarctica, Asia, Atlantic, Australia, Pacific

  return "US";
};
